module.exports = __webpack_public_path__ + "static/img/top-seller-badge.55fbe849.svg";